"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePropertyDetailsSummaryWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordionPlugin_1 = require("../../../components/FalconAccordionPlugin");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var Detail = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail" }, children);
};
var DetailKey = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-key" }, children);
};
var DetailValue = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: "detail-value" }, children);
};
var AnnualHomePropertyDetailsSummaryWidget = exports.AnnualHomePropertyDetailsSummaryWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePropertyDetailsSummaryWidget, _super);
    function AnnualHomePropertyDetailsSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditPropertyUsePage = function () {
            _this.props.engine.setJourneyState({
                idToScrollTo: "propertyDetailsWidgetId"
            });
            _this.props.engine.navigate("yourDetails", false);
        };
        _this.fetchLookupValues = function () {
            var languageCode = "en-UK";
            var valuesToPopulate = [
                {
                    classifier: "roofMaterial",
                    field: _this.realEstate.roofMaterial,
                    stateName: "roofMaterial"
                },
                {
                    classifier: "wallMaterial",
                    field: _this.realEstate.externalWallMaterial,
                    stateName: "externalWallMaterial"
                },
                {
                    classifier: "flatRoofPercentage",
                    field: _this.realEstate.flatRoofPercentage,
                    stateName: "flatRoofPercentage"
                },
                {
                    classifier: "propertyListing",
                    field: _this.realEstate.propertyListing,
                    stateName: "propertyListing"
                }
            ];
            valuesToPopulate.forEach(function (item) {
                var lookupFieldValue = item.field == null ? undefined : item.field;
                _this.lookupService.fetchLookupValues(item.classifier, languageCode, lookupFieldValue).subscribe(function (lookupValues) {
                    var _a;
                    var fetchedLookupItem = lookupValues.find(function (lookupValue) { return lookupValue.id === item.field; });
                    if (fetchedLookupItem) {
                        _this.setState((_a = {}, _a[item.stateName] = fetchedLookupItem.value, _a));
                    }
                });
            });
        };
        _this.realEstate = _this.props.interaction.realEstate[0];
        _this.state = {
            realEstateTypeSubType: "",
            externalWallMaterial: "",
            roofMaterial: "",
            flatRoofPercentage: "",
            propertyListing: "",
        };
        return _this;
    }
    AnnualHomePropertyDetailsSummaryWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues();
        this.fetchRealEstateTypeSubtypePresetParameters();
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.render = function () {
        return (React.createElement("div", { id: "propertyDetailsWidgetId", className: "collapsible-question-panel quote-details-widget" },
            React.createElement(FalconAccordionPlugin_1.FalconAccordion, { togglePositionTop: true, isShownClassName: "shown", toggleShown: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Property details"),
                    React.createElement("span", { className: "toggle-icon collapse-icon" })), toggleHidden: React.createElement("div", { className: "toggle d-flex justify-content-between align-items-center" },
                    React.createElement("span", null),
                    React.createElement("span", { className: "font-weight-bold text-center fs-18" }, "Property details"),
                    React.createElement("span", { className: "toggle-icon expand-icon" })) }, this.renderPropertyUseDetails())));
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.renderPropertyUseDetails = function () {
        return (React.createElement("div", { className: "accordion-content grid-make-2-col" },
            React.createElement("img", { className: "home-image mb-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/home-icon.png"), alt: "Home icon" }),
            React.createElement("div", { className: "section border-0 p-0" },
                React.createElement("div", { className: "section-contents mb-5" },
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Address:"),
                        React.createElement(DetailValue, null, (0, commonFunctions_1.getFullAddressString)(this.realEstate.address))),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Property type:"),
                        React.createElement(DetailValue, null, this.state.realEstateTypeSubType)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Number of rooms:"),
                        React.createElement(DetailValue, null,
                            this.realEstate.bedroomCount,
                            this.realEstate.bedroomCount > 1 ? " bedrooms, " : " bedroom, ",
                            this.realEstate.bathroomCount,
                            this.realEstate.bathroomCount > 1 ? " bathrooms" : " bathroom")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Good state of repair:"),
                        React.createElement(DetailValue, null, this.realEstate.propertyCondition === "GOOD" ? "Yes" : "No")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Walls:"),
                        React.createElement(DetailValue, null, this.state.externalWallMaterial)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Roof:"),
                        React.createElement(DetailValue, null, this.state.roofMaterial)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Percentage of flat roof:"),
                        React.createElement(DetailValue, null, this.state.flatRoofPercentage)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Year built:"),
                        React.createElement(DetailValue, null, this.realEstate.yearBuilt)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Listed building:"),
                        React.createElement(DetailValue, null, this.state.propertyListing)),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Suffered from subsidence:"),
                        React.createElement(DetailValue, null, this.realEstate.subsidenceHeaveOrLandslip ? "Yes" : "No")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Been flooded:"),
                        React.createElement(DetailValue, null, this.realEstate.floodRisk ? "Yes" : "No")),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Smart home systems:"),
                        React.createElement(DetailValue, null, this.renderInstalledSmartHomeSystems())),
                    React.createElement(Detail, null,
                        React.createElement(DetailKey, null, "Oil-fired heating system:"),
                        React.createElement(DetailValue, null, this.realEstate.oilFiredHeatingInstalled ? "Yes" : "No")))),
            React.createElement("button", { type: "button", className: "btn btn-primary btn-add btn-summary-chapter grid-col-2", onClick: this.navigateToEditPropertyUsePage }, "Edit property details")));
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.renderInstalledSmartHomeSystems = function () {
        var homeSystems = [];
        if (!this.realEstate.installedSmartHomeSystems) {
            homeSystems.push(React.createElement("span", null,
                "None",
                React.createElement("br", null)));
        }
        else {
            if (this.realEstate.installedSmartHomeSystems.remoteHeatingControl) {
                homeSystems.push(React.createElement("span", null,
                    "Remote heating control",
                    React.createElement("br", null)));
            }
            if (this.realEstate.installedSmartHomeSystems.securityCamera) {
                homeSystems.push(React.createElement("span", null,
                    "Security camera",
                    React.createElement("br", null)));
            }
            if (this.realEstate.installedSmartHomeSystems.waterLeakDetector) {
                homeSystems.push(React.createElement("span", null,
                    "Water leak detector",
                    React.createElement("br", null)));
            }
            if (this.realEstate.installedSmartHomeSystems.waterShutOffValve) {
                homeSystems.push(React.createElement("span", null,
                    "Automatic water shut off valve",
                    React.createElement("br", null)));
            }
            if (homeSystems.length === 0) {
                homeSystems.push(React.createElement("span", null,
                    "None",
                    React.createElement("br", null)));
            }
        }
        return (React.createElement("div", null, homeSystems));
    };
    AnnualHomePropertyDetailsSummaryWidget.prototype.fetchRealEstateTypeSubtypePresetParameters = function () {
        var _this = this;
        this.falconConvenienceApiService.getRealEstateTypeSubtypeParams(services_1.PRODUCT_ANNUAL_HOME)
            .subscribe(function (output) {
            var _a;
            var arrayOfTypeSubType = output.filter(function (typeSubType) { return _this.props.interaction.realEstate[0].realEstateTypeSubType === typeSubType.typeSubTypeCode; });
            if (arrayOfTypeSubType.length === 1) {
                var resultText = arrayOfTypeSubType[0].subtype + " " + ((_a = arrayOfTypeSubType[0].type) !== null && _a !== void 0 ? _a : "").toLowerCase();
                _this.setState({
                    realEstateTypeSubType: (0, commonFunctions_1.capitalizeFirstLetter)(resultText.replace("None", ""))
                });
            }
        });
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomePropertyDetailsSummaryWidget.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], AnnualHomePropertyDetailsSummaryWidget.prototype, "falconConvenienceApiService", void 0);
    return AnnualHomePropertyDetailsSummaryWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomePropertyDetailsSummaryWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomePropertyDetailsSummaryWidget.js
// module id = 3683
// module chunks = 0